<template>
	<div>
		<div :class="{'hidden':hidden}" class="pagination-container">
			<el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize"
				:layout="layout" :page-sizes="pageSizes" :total="total" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</div>
	</div>
	
</template>

<script>
	//分页组件
	export default {
		name:'FenPage',
		props: {
			total: {
				required: true,
				type: Number
			},
			page: {
				type: Number,
				default: 1
			},
			limit: {
				type: Number,
				default: 20
			},
			pageSizes: {
				type: Array,
				default () {
					return [10, 20, 50, 100, 200, 1000]
				}
			},
			layout: {
				type: String,
				default: 'total,  prev, pager, next, jumper',
			},
			background: {
				type: Boolean,
				default: true,
			},
			hidden: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			currentPage: {
				get() {
					return this.page
				},
				set(val) {
					this.$emit('update:page', val)
				}
			},
			pageSize: {
				get() {
					return this.limit
				},
				set(val) {
					this.$emit('update:limit', val)
					this.$emit('update:page', 1)
				}
			}
		},
		methods: {
			handleSizeChange(val) {
				this.$emit('pagination', {
					page: this.currentPage,
					limit: val
				})
			},
			handleCurrentChange(val) {
				this.$emit('pagination', {
					page: val,
					limit: this.pageSize
				})
			}
		}
	}
</script>

<style>
</style>